import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const ClaudeChatConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className={commonStyles.label}>
          API Kulcs
        </label>
        <input
          type="password"
          value={node.data.config?.apiKey || ''}
          onChange={(e) => updateConfig('apiKey', e.target.value)}
          placeholder="sk-ant-..."
          className={commonStyles.input}
        />
      </div>
      
      <div>
        <label className={commonStyles.label}>
          Modell
        </label>
        <select
          value={node.data.config?.model || 'claude-3-sonnet-20240229'}
          onChange={(e) => updateConfig('model', e.target.value)}
          className={commonStyles.select}
        >
          <option value="claude-3-sonnet-20240229">Claude 3 Sonnet</option>
          <option value="claude-3-opus-20240229">Claude 3 Opus</option>
          <option value="claude-3-haiku-20240307">Claude 3 Haiku</option>
        </select>
      </div>

      <div>
        <label className={commonStyles.label}>
          Prompt
        </label>
        <textarea
          value={node.data.config?.prompt || ''}
          onChange={(e) => updateConfig('prompt', e.target.value)}
          placeholder="Add meg a kérdést vagy utasítást..."
          rows={4}
          className={commonStyles.textarea}
        />
      </div>

      <div>
        <label className={commonStyles.label}>
          Max Tokenek
        </label>
        <input
          type="number"
          value={node.data.config?.maxTokens || 1000}
          onChange={(e) => updateConfig('maxTokens', parseInt(e.target.value))}
          min="1"
          max="4000"
          className={commonStyles.input}
        />
      </div>
    </div>
  );
};

export default ClaudeChatConfig;
